<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap justify-center align-end>
      <v-flex v-for="(text,i) in textos" :key="'text'+i" class="xs12" :class="i<3?'md4':'md6'">
        <v-layout wrap justify-center class="item-container">
          <p v-if="vistos[i]" class="bubble animated fadeIn">{{text}}</p>
          <div class="text-xs-center">
            <button @click="$set(vistos,i,true)" class="image-button hvr-shrink"><img :src="require('../../assets/presentacion/diapositiva-4-'+ (i + 1) +'.png')" :alt="titulos[i]"></button>
            <p aria-hidden class="flex xs12 button-title">{{titulos[i]}}</p>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 3/AUDIO 16'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "Recordemos la noticia con la que iniciamos el curso. Después de haber aprendido sobre las reservas y los recursos, veamos el cambio en las impresiones de los lectores." 
      ],
      titulos: [
        "Inversionista",
        "Ejecutivo del sector financiero",
        "Gobierno",
        "Empresas",
        "Empleado operario"
      ],
      textos: [
        "Efectivamente, las reservas y los recursos afectan nuestras acciones y le permiten a Ecopetrol buscar un negocio a largo plazo. Por eso, ¡confiamos en Ecopetrol!",
        "Señores, en conclusión y para cerrar esta reunión, notaron la importancia de las reservas y cómo estas afectan al sector financiero. Por eso, su rigurosidad para ser estimadas.",
        "Efectivamente, confiamos en una empresa como Ecopetrol, que cumple con las exigencias y normativas de control y reporte, establecidos interna y externamente. Por eso, podemos asegurar nuestras inversiones",
        "Gracias a que el objetivo de Ecopetrol es ser un jugador internacional con capacidad para incorporar reservas y aumentar la producción de petróleo y gas de forma sostenida.",
        "Para Ecopetrol S.A. las reservas y los recursos de hidrocarburos constituyen un activo fundamental para el cumplimiento del plan estratégico definido por la compañía. Por lo cual, es muy importante garantizar un proceso interno de estimación y reporte de reservas que cumpla con las exigencias normativas, de control y reporte establecidos interna y externamente."
      ],
      vistos: Array(5).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(value) {
      var todosVistos = value.every(el => {return el})
      if (todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.image-button{
  max-width: 175px;
}

.button-title {
  text-align: center;
  font-weight: bold;
  font-family: HelveticaNeueCn;
  font-size: 1.2em;
}

.bubble {
  background-color: white;
  color: black;
  padding: 10px;
  margin: 10px;
  margin-bottom: 20px;
  position: relative;
  &::after {
    // Flecha
    content: " ";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border: 15px solid transparent;
    border-top-color: white;
    bottom: -30px;
    left: calc(50% - 10px);
  }
}
</style>
